export enum billsTypeEnum {
    'All Bills' = 1,
    'Past Due Bills' = 2,
    'Due This Month' = 3,
    'Paid Bills' = 4
}
